<header
  (window:resize)="screenWidth()"
  (click)="handleClick($event)"
  [style.background-color]="
    router.url == '/home' ? 'rgba(0, 28, 57, 0.5)' : 'var(--color-primary)'
  "
>
  <div class="header-content">
    <button
      mat-icon-button
      class="burger"
      (click)="activeBurger = !activeBurger"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <section class="brand">
      <a
        [routerLink]="user?.registered ? '/' : '/home'"
        (click)="hideMenuIfNeeds()"
      >
        <img src="/assets/ws3-inverted.png" alt="ws3" />
      </a>
    </section>

    <nav
      [class.menu-open]="activeBurger"
      [ngClass]="{ 'menu-home': activeBurger && router.url == '/home' }"
    >
      <div class="menu">
        <a
          *ngIf="user?.registered && permissions.temAcessoMyVessel"
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="hideMenuIfNeeds()"
        >
          My Vessels
        </a>
        <a
          *ngIf="user && permissions.temAcessoPortLineup"
          routerLink="/port-lineup"
          routerLinkActive="active"
          (click)="hideMenuIfNeeds()"
        >
          Port Line Up
        </a>
        <a
          routerLink="/handbooks"
          routerLinkActive="active"
          (click)="hideMenuIfNeeds()"
        >
          Handbooks
        </a>
        <a
          *ngIf="user && permissions.temAcessoPortSearch"
          routerLink="/port-searcher"
          routerLinkActive="active"
          (click)="hideMenuIfNeeds()"
        >
          Port Searcher
        </a>
        <a
          *ngIf="user?.registered && permissions.temAcessoReports"
          routerLink="/reports"
          routerLinkActive="active"
          (click)="hideMenuIfNeeds()"
        >
          Reports
        </a>
        <a
          routerLink="/port-news"
          routerLinkActive="active"
          (click)="hideMenuIfNeeds()"
        >
          Port News
        </a>
        <a
          *ngIf="user?.registered && permissions.temAcessoPortSearch"
          routerLink="/port-cost-estimator"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="hideMenuIfNeeds()"
        >
          Port Cost Estimator
        </a>
        <!-- <a
          routerLink="/subscription-plans"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="hideMenuIfNeeds()"
        >
          Subscription Plans
        </a> -->
        <a
          routerLink="/contact-us"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="hideMenuIfNeeds()"
        >
          Contact Us
        </a>
      </div>
    </nav>

    <div class="space"></div>
    <div class="tools">
      <fa-icon
        [icon]="faCloudSunRain"
        (click)="handleWeather()"
        size="2x"
        alt="Weather Forecast"
        title="Weather Forecast"
      ></fa-icon>
      <a href="https://t.me/WilsonAgenciamento_bot" target="_blank">
        <fa-icon
          [icon]="faTelegramPlane"
          size="2x"
          alt="Telegram"
          title="Telegram"
        ></fa-icon>
      </a>
    </div>

    <button
      *ngIf="user?.registered"
      class="dropdown"
      [matMenuTriggerFor]="menu"
    >
      <span *ngIf="!userIcon"
        >Hi, <strong>{{ user?.name }}</strong></span
      >
      <span id="pliqUserID" style="display: none; visibility: collapse">{{
        user?.id
      }}</span>
      <mat-icon *ngIf="!userIcon">keyboard_arrow_down</mat-icon>
      <mat-icon *ngIf="userIcon">person</mat-icon>

      <mat-menu
        #menu="matMenu"
        class="user-menu"
        xPosition="before"
        yPosition="below"
      >
        <span class="menu-span" mat-menu-item disabled *ngIf="userIcon"
          >Hi, <strong>{{ user?.name }}</strong
          >!</span
        >
        <button mat-menu-item (click)="handleSettings()">
          <mat-icon>settings</mat-icon>Settings
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>Logout
        </button>
      </mat-menu>
    </button>

    <div *ngIf="!user?.registered">
      <button
        mat-raised-button
        color="white"
        (mouseover)="(accent)"
        (click)="handleLogin()"
      >
        LOGIN
      </button>
    </div>
  </div>
</header>
